.ux-iws-teaser-image {
    display: flex;
    position: relative;
    flex-direction: column;

    .ux-iws-link-wrapper {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    a {
        text-decoration: none;
    }

    &__image-wrapper {
        display: block;
        position: relative;
        width: 100%;
        height: 0;
        overflow: hidden;

        img {
            display: block;
            position: absolute;
            width: 100%;
            height: 100%;
            min-height: 100%;
            top: 0;
            left: 0;
            transition: all $animationSpeed-normal $animationEasing-ease;
        }

        .ux-iws-teaser-image__image-alternative {
            position: absolute;
            width: 100%;
            height: 100%;
            min-height: 100%;
            top: 0;
            left: 0;
            transition: all $animationSpeed-normal $animationEasing-ease;
        }

        img:focus,
        .ux-iws-teaser-image__image-alternative:focus {
            outline: none;
        }
    }

    // specific styles for image auto height
    &__image-wrapper--auto-height img,
    &__image-wrapper--auto-height .ux-iws-teaser-image__image-alternative {
        height: auto;
        transform: translateY(-50%) !important;
        top: 50%;
        max-width: none;
        will-change: left, width;
    }

    &:hover {
        .ux-iws-teaser-image__image-wrapper--auto-height img,
        .ux-iws-teaser-image__image-wrapper--auto-height
            .ux-iws-teaser-image__image-alternative {
            width: 105%;
            left: -2.5%;
        }
    }

    &__info-wrapper {
        padding: 25px 30px 30px;
        flex: 1 0 auto;
        display: flex;
        flex-direction: column;

        &--space-between {
            justify-content: space-between;
        }
    }

    &__title {
        margin: 0;
        color: $color-black;
    }

    p {
        margin-bottom: 0;
    }

    &__text-wrapper {
        flex: 1 0 auto;
        display: flex;
        flex-direction: column;
    }

    &__text-wrapper--row {
        align-items: flex-end;
        flex-direction: row;

        > *:first-child:not(:last-child) {
            margin-right: 20px;
        }

        .ux-text-lines-limit {
            align-self: stretch;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
        }
    }

    &__text-wrapper--align-cta-top {
        justify-content: space-between;
        align-items: flex-start;
        flex: 0 0 auto;

        .ux-text-lines-limit {
            justify-content: flex-start;
        }
    }

    &__text-wrapper--column {
        justify-content: space-between;
        align-items: stretch;
    }

    // tag styles specific for this teaser
    .ux-tag {
        letter-spacing: 0.2px;
        font-size: $size-text-tiny;
        height: auto;
        padding: 6px 10px;
    }

    &:hover {
        img,
        .ux-iws-teaser-image__image-alternative {
            transform: scale(1.05);
        }

        a {
            background-color: $color-black;
            color: $color-white;
        }

        ux-icon {
            fill: $color-white;
        }

        *[data-trigger-modal] ux-icon {
            fill: initial;
        }
    }

    &__text-wrapper--inline-text {
        align-items: flex-start;

        .ux-label {
            display: block;
            color: $color-black;
        }

        [slot="text"] > *:not(.ux-label) {
            display: inline;
        }
    }

    &--green-border {
        border: 2px solid $color-green;
    }

    .ux-slider--slides-auto-height & {
        height: 100%;
    }
}

.ux-iws-teaser-image-grid {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 100%;
    justify-content: space-between;

    > * {
        width: 100%;
        margin-bottom: 30px;

        @media only screen and (min-width: 568px) and (max-width: 767px) {
            width: calc(50% - 15px);
        }

        @media only screen and (min-width: 768px) {
            width: calc(33.3333% - 20px);
        }
    }

    @media only screen and (min-width: 768px) {
        justify-content: flex-start;

        > *:not(:nth-child(3n)) {
            margin-right: 30px;
        }
    }

    &--3-xl > * {
        margin-left: 15px !important;
        margin-right: 15px !important;
    }

    &--3-xl > * {
        @media only screen and (min-width: 568px) and (max-width: 767px) {
            width: 100%;
        }

        @media only screen and (min-width: 768px) and (max-width: 1439px) {
            width: calc(50% - 30px);
        }

        @media only screen and (min-width: 1440px) {
            width: calc(33.3333% - 30px);
        }
    }
}
